export const AUTHORIZED_SIGNATORY_DOCUMENT_TYPES = {
  AUTHORIZED_SIGNATORY_LIST: {
    value: "authorized_signatory_list",
    readableName: "Authorized Signatory List",
  },
  INCUMBENCY_CERTIFICATE: {
    value: "incumbency_certificate",
    readableName: "Incumbency Certificate",
  },
  SIGNATORY_AUTHORIZATION_FORM: {
    value: "signatory_authorization_form",
    readableName: "Signatory Authorization Form",
  },
  OTHER: {
    value: "other",
    readableName: "Other",
  },
};

export const authorizedSignatoryDocumentTypesArray = Object.values(
  AUTHORIZED_SIGNATORY_DOCUMENT_TYPES,
);
